export const CHAT_ROUTE = "/chat";

export function isChatRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return pathname === CHAT_ROUTE || pathname.startsWith(`${CHAT_ROUTE}/`);
}
